import {Controller} from "stimulus"
import $ from 'jquery';

export default class extends Controller {
    connect() {
        // INFO DE PANTALLAS ACTIVAS
        let url = `${window.location.origin}/monitors_counter`;
        fetch(url).then(res => {
            if(!res.ok){
                throw new Error ("No se pudo acceder a la solicitud de conteo de pantallas activas");
            }
            return res.json();
        }).then(data => {
            console.log(data);
        }).catch(err => {
            console.log('Error:' + err);
        });
    }

    open_new_window() {
        let img = document.querySelector('.img-fluid')
        let urlImg = img.src
            if (!window.open(urlImg, '_blank', 'popup=1')){
                alert("En este navegador no están permitidas las ventanas emergentes. Habilite dicha opción si quiere visualizar este PopUp.");
            }

    }

}

